





























import Vue from 'vue';
import SearchBanner from './components/banner/SearchBanner.vue';
import SearchBannerForm from './components/banner/form/SearchBannerForm.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'HotelsSearchBanner',
  components: {
    SearchBanner,
    SearchBannerForm,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    cityUnique: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('hotelsSearchBanner', {
      loading: 'isLoading',
      image: 'image',
      date: 'dateData',
      city: 'cityData',
      amount: 'amountData',
    }),
  },
  methods: {
    handleSubmit() {
      const queryParams = new URLSearchParams({
        rooms: this.amount.toString(),
      });

      if (this.date?.fromDate) {
        queryParams.append('from_date', this.date.fromDate);
      }

      if (this.date?.toDate) {
        queryParams.append('till_date', this.date.toDate);
      }

      if (this.date?.dateShortcut) {
        queryParams.append('date_shortcut', this.date.dateShortcut);
      }

      const url = `/hotels/${this.city.slug}/?${queryParams.toString()}`;
      window.location.href = url;
    },
  },
  mounted() {
    this.$store.dispatch('hotelsSearchBanner/fetchInitialData', this.cityUnique);
  },
});
